const data = [
    {
      id: 1,
      title: "Work Ethics with Ankur Warikoo",
      description:
        'I will share with you what I call "Positively Impactful Moments of Disappointment." Throughout my career, many of my highest moments only came after setbacks and losses. But learning from those difficult moments is what gave me the ability to rise above them and reach my goals.',
      price: 100,
      coverImg: "ankur-warikoo.png",
      stats: {
        rating: 4.9,
        reviewCount: 65,
      },
      location: "Online",
      openSpots: 0,
    },
    {
      id: 2,
      title: "Learn Canyon Photography",
      description:
        "Interested in becoming a nature photographer? For beginner and experienced photographers alike, join us in learning techniques required to leave the wandarlust travellers a memory of a lifetime.",
      price: 125,
      coverImg: "grand-canyon.png",
      stats: {
        rating: 5.0,
        reviewCount: 30,
      },
      location: "Arizona, USA",
      openSpots: 27,
    },
    {
      id: 3,
      title: "Solo Mountain Biking",
      description:
        "Experience the beautiful Norwegian landscape and meet new friends all while conquering rugged terrain on your mountain bike. (Bike provided!)",
      price: 50,
      coverImg: "mountain-bike.png",
      stats: {
        rating: 4.8,
        reviewCount: 2,
      },
      location: "Fjords, Norway",
      openSpots: 3,
    },
    {
      id: 4,
      title: "Sightseeing in Japan",
      description:
        "Explore the city of lush pink trees and blossom flowers on foot and experience serenity of a lifetime.",
      price: 250,
      coverImg: "japan-forest.png",
      stats: {
        rating: 4.2,
        reviewCount: 22,
      },
      location: "Kyoto, Japan",
      openSpots: 0,
    },
    {
      id: 5,
      title: "Stand-Up with Bassi",
      description: "Laugh to your hearts content as Bassi takes",
      price: 135,
      coverImg: "stand-up.png",
      stats: {
        rating: 5,
        reviewCount: 120,
      },
      location: "Online",
      openSpots: 31,
    },
    {
      id: 6,
      title: "Diving in The Great Barrier Reef",
      description:
        "Experience the serene and beautiful sealife just North of Sydny. 1 hour of tranquilness!",
      price: 580,
      coverImg: "scuba-diving.png",
      stats: {
        rating: 4.4,
        reviewCount: 92,
      },
      location: "Sydny, Australia",
      openSpots: 53,
    },
  ];
  
  export default data;